<template>
    <sub-account-link v-if="!nameIsHeader(name) && subAccount" :uuid="subAccount.uuid" class="text-primary">
        {{ name }}
    </sub-account-link>
    <div v-else>
        {{ name }}
    </div>
</template>

<script setup lang="ts">
import {computed, provide} from 'vue'
import SubAccountLink from '@/subaccount/components/SubAccountLink.vue'

const props = defineProps({
    params: {required: true, type: Object}
})

provide('panelId', props.params.context.panelId)

const subAccount = computed(() => {
    return props.params.data
})

const name = computed(() => {
    return subAccount.value.name
})

function nameIsHeader (name: String) {
    if (name == 'Sum' || name == 'Prosentandel')
        return true
    return false
}

</script>

<style>

</style>